import React, { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@store/store'
import {
  fetchPlaylistById,
  selectIsPlaylistIdInProgress,
  selectPlaylistById,
} from '@store/slices/playlist.slice'
import { EntityId } from '@reduxjs/toolkit'
import SlotAudioComponent from '@components/slot/slotAudio.component'
import { DjangoFilter } from '@store/slices/generic.slice'
import {
  AISlotModel,
  fetchAllAiSlots,
  selectAiSlotLoading,
  selectAiSlotsByIds,
} from '@store/slices/aiSlot.slice'
import { fetchAllMetadataBySlotIds } from '@store/thunk/aimeta.thunk'

const PlaylistAudioListComponent: FC = () => {
  const { playlistId } = useParams()
  const dispatch = useDispatch<AppDispatch>()
  const playlist = useSelector((state: RootState) =>
    playlistId ? selectPlaylistById(state, playlistId) : null
  )
  const playlistLoading = useSelector((state: RootState) =>
    playlistId ? selectIsPlaylistIdInProgress(state, playlistId) : playlistId
  )

  const aiSlotsLoading = useSelector(selectAiSlotLoading)

  const aiSlots: AISlotModel[] = useSelector((state: RootState) =>
    playlist ? selectAiSlotsByIds(state, playlist.aiSlots) : null
  )

  useEffect(() => {
    if (playlistId && !playlistLoading && !playlist) {
      dispatch(fetchPlaylistById(playlistId))
    }
  }, [])

  useEffect(() => {
    if (
      playlist &&
      !aiSlotsLoading &&
      aiSlots.length !== playlist.aiSlots.length
    )
      fetchSlotsForPlaylist()
  }, [playlist])

  const fetchSlotsForPlaylist = () => {
    const filter = new DjangoFilter<AISlotModel>()
    playlist && filter.addIdFilter(playlist.aiSlots)
    dispatch(fetchAllAiSlots(filter))
    playlist && dispatch(fetchAllMetadataBySlotIds(playlist.aiSlots))
  }

  // Playlist component details here
  return (
    <div className={'my-2 overflow-scroll'} style={{ maxHeight: '800px' }}>
      {playlist &&
        playlist.aiSlots &&
        playlist.aiSlots.map((slotId: EntityId) => (
          <SlotAudioComponent key={slotId} slotId={slotId}></SlotAudioComponent>
        ))}
    </div>
  )
}

export default PlaylistAudioListComponent
